import firebaseApp from "../firebase/credenciales";
import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";

const db = getFirestore(firebaseApp);

/**
 * Revisa si el correo ya está registrado en el padrón de trabajadores.
 *
 * Se usa para AVISAR antes de crear, nunca para bloquear: las empresas dan de
 * alta a sus trabajadores y el correo puede venir mal capturado. Si el
 * correo ya pertenece a OTRA ficha, el modal pregunta y deja continuar.
 *
 * @param {string} email        correo a verificar
 * @param {string} rucEmpresa   empresa del solicitante
 * @returns {Promise<{existe: boolean, fichas: Array}>}
 */
const comprobarCorreoExistente = async (email, rucEmpresa) => {
  const correo = String(email || "").trim().toLowerCase();
  if (!correo) return { existe: false, fichas: [] };

  try {
    const q = query(
      collection(db, "users"),
      where("email", "==", correo),
      where("rucEmpresa", "==", rucEmpresa)
    );
    const snapshot = await getDocs(q);
    const fichas = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    return { existe: fichas.length > 0, fichas };
  } catch (error) {
    // Si la consulta falla (índice, permisos…) el servidor sigue siendo la
    // autoridad: se continúa con el alta sin aviso previo.
    console.error("No se pudo comprobar el correo previo:", error);
    return { existe: false, fichas: [] };
  }
};

export default comprobarCorreoExistente;
